import { render, staticRenderFns } from "./BandejaLinkPresentarReplicaComponente.vue?vue&type=template&id=452621a1"
import script from "./BandejaLinkPresentarReplicaComponente.vue?vue&type=script&lang=js"
export * from "./BandejaLinkPresentarReplicaComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports